<template>
  <div>
    <div class="login-page">
      <top></top>
      <div class="container">
        <el-page-header @back="goBack"> </el-page-header>
        <div class="row">
          <div class="rowLeft">
            <div class="blog-header">
              <h1 class="blog-title">第18届中国国际花卉园艺展</h1>
            </div>
            <div class="blog-post">
              <h2 class="blog-post-summary">
                中国国际花卉园艺展览会由中国花卉协会主办，每年在北京、上海两地轮流举办。
              </h2>
              <!-- <p class="blog-post-meta">by <a href="#">易奇签到</a></p> -->
              <hr />
              <p>
                中国国际花卉园艺展览会由中国花卉协会主办，每年在北京、上海两地轮流举办。展会得到了农业部和国家林业局的大力支持，是中国花卉、园艺、园林领域规模最大、知名度最高、贸易效果最好的专业性展览会；已成为国内外专业人士每年踊跃参加的品牌展览会.
              </p>
            </div>
          </div>
          <div class="rowRight">
            <div class="to-slide-panel to-panel-hot-news">
              <div class="to-slide-header">
                <span>热门案例</span>
              </div>
              <div class="to-slide-body" id="hotarticllist">
                <ul>
                  <li>
                    <span class="to-index to-index-1">1</span
                    ><a title="" href="/Home/SuccessDetail/10"
                      >第18届中国国际花卉园艺展</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-2">2</span
                    ><a title="" href="/Home/SuccessDetail/9"
                      >全球视野，创新长青 ——中信•泰达创新论坛</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-3">3</span
                    ><a title="" href="/Home/SuccessDetail/6"
                      >2017（第二届）中国CEO新年峰会</a
                    >
                  </li>
                  <!-- <li>
                    <span class="to-index to-index-4">4</span
                    ><a title="" href="/Home/SuccessDetail/5"
                      >2016中国数据中心年度论坛</a
                    >
                  </li>
                  <li>
                    <span class="to-index to-index-5">5</span
                    ><a title="" href="/Home/SuccessDetail/4"
                      >易奇会议助力首届世界互联网大会</a
                    >
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "./_foot";
import top from "./_top_menu";
export default {
  components: {
    Foot,
    top,
  },
  data() {
    return {};
  },
  created() {},

  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus();
      },
    },
  },

  methods: {
    goBack() {
      if (this.$route.query.flag == 1) {
        this.$router.push("/success");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  background-color: #fff;
  // height: 100vh;
  .loginBtn {
    cursor: pointer;
  }
  .container {
    width: 1170px;
    margin: 0 auto;
    padding-top: 60px;
    height: 100vh;
    .row {
      width: 1170px;
      margin: 0 auto;
      display: flex;
      padding-top: 40px;

      justify-content: space-between;
      .rowLeft {
        width: 75%;
        padding-right: 15px;
        padding-left: 15px;
        .blog-header {
          text-align: center;
        }
        .blog-title {
          margin-bottom: 0;
          font-size: 30px;
          font-weight: normal;
        }
        .blog-post-summary {
          border: 1px solid #ccc;
          padding: 5px;
          line-height: 22px;
          text-indent: 24px;
          font-size: 12px;
        }
        h2 {
          margin-top: 20px;
          margin-bottom: 10px;
          color: inherit;
          font-size: 14px;
        }
        hr {
          margin-top: 20px;
          margin-bottom: 20px;
          border: 0;
          border-top: 1px solid #eee;
        }
        p {
          margin: 0 0 10px;
        }
      }
      .rowRight {
        a {
          color: #6e6e6e;
        }
        .to-slide-header {
          font-size: 18px;
          border-bottom: 1px #e2e2e2 solid;
          span {
            border-bottom: 2px #949494 solid;
            padding-bottom: 5px;
            display: inline-block;
          }
        }
        .to-slide-body {
          padding: 10px 0 10px 0;
          color: #8e8e8e;
          font-size: 12px;
        }
        .to-panel-hot-news li {
          margin-bottom: 17px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .to-index {
          width: 20px;
          height: 20px;
          font-size: 12px;
          display: inline-block;
          background: #b4b4b4;
          margin-right: 10px;
          border-radius: 50%;
          text-align: center;
          color: white;
          line-height: 18px;
        }
        .to-index-1 {
          background-color: #f93b08 !important;
        }
        .to-index-2 {
          background-color: #ffa800 !important;
        }
        .to-index-3 {
          background-color: #0cf !important;
        }
      }
    }
  }
}
.copy-right {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 10px 0;
}
</style>
